"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.url = void 0;
const utils_common_1 = require("@agilepoint/utils-common");
const messages_1 = require("./messages");
function url(value, options) {
    if ((0, utils_common_1.isURL)(value)) {
        return undefined;
    }
    return options && options.message ? options.message : messages_1.messages.invalidURL;
}
exports.url = url;
//# sourceMappingURL=url.js.map